import { useState } from 'react'
import { FaEdit, FaTrash } from 'react-icons/fa'
import { Accrual } from '../../data/interfaces'
import './Grids.css'

interface AccrualsGridProps {
  accruals: Accrual[]
  onAdd: () => void
  onEdit: (accrual: Accrual) => void
  onDelete: (accrualId: number) => void
  lockEdit: boolean
}

const AccrualsGrid = (props: AccrualsGridProps) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
    }).format(value)
  }

  const calculateTotal = () => {
    return props.accruals.reduce((sum, accrual) => sum + accrual.value, 0)
  }

  return (
    <div style={{ padding: '0 1rem 1rem' }}>
      {props.accruals.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
          No accruals found for this job.
        </p>
      ) : (
        <>
          <div style={{ overflowX: 'auto' }}>
            <table className="grid__table" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Description</th>
                  <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #ddd' }}>Value</th>
                  {!props.lockEdit && (
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd', width: '120px' }}>Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {props.accruals.map((accrual) => (
                  <tr key={accrual.accrualId} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{accrual.description}</td>
                    <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                      {formatCurrency(accrual.value)}
                    </td>
                    {!props.lockEdit && (
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                          <FaEdit
                            style={{ cursor: 'pointer', color: '#1e2a4e', fontSize: '16px' }}
                            onClick={() => props.onEdit(accrual)}
                            title="Edit Accrual"
                          />
                          <FaTrash
                            style={{ cursor: 'pointer', color: '#e9530d', fontSize: '16px' }}
                            onClick={() => {
                              if (window.confirm('Are you sure you want to delete this accrual?')) {
                                props.onDelete(accrual.accrualId)
                              }
                            }}
                            title="Delete Accrual"
                          />
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ backgroundColor: '#f9f9f9', fontWeight: 'bold' }}>
                  <td style={{ padding: '12px', borderTop: '2px solid #ddd' }}>Total</td>
                  <td style={{ padding: '12px', textAlign: 'right', borderTop: '2px solid #ddd' }}>
                    {formatCurrency(calculateTotal())}
                  </td>
                  {!props.lockEdit && <td style={{ borderTop: '2px solid #ddd' }}></td>}
                </tr>
              </tfoot>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

export default AccrualsGrid
